import { RootState, StoreUtilService } from "@app/shared"
import { ActionReducer, MetaReducer } from "@ngrx/store"
import { DEFAULT_EQUIPMENT_FILTERS } from "../reducers"
export const clean = (storeService: StoreUtilService): MetaReducer<RootState> => {
    return (reducer: ActionReducer<any>) => {
        return function (state, action) {
            const initialState = storeService.originState
            // console.log(action.type)
            switch (action.type) {
                case '@ngrx/router-store/navigated':
                    storeService.updateInitialState({
                        ...state,
                        core: {
                            ...state.core,
                            trips: {
                                ...state.core.trips,
                                filter: null,
                            },
                            equipments: {
                                ...state.core.equipments,
                                equipments: [],
                                filter: DEFAULT_EQUIPMENT_FILTERS(),
                            }
                        }
                    })
                    return reducer(storeService.originState, action)
                case '[ROOT] CLEAN_STORE':
                    if (initialState) {
                        storeService.updateInitialState({
                            sidebar: state.sidebar,
                            auth: state.auth,
                            core: {
                                ...initialState.core,
                                toasts: state?.core?.toasts,
                                lockedItems: state?.core?.lockedItems,
                                visitItems: state?.core?.visitItems,
                                orders: {
                                    ...initialState.core.orders,
                                    filters: state?.core?.orders?.filters
                                },
                                candidates: {
                                    ...initialState.core.candidates,
                                    filter: state?.core?.candidates?.filter
                                },
                                schedules: {
                                    ...initialState.core.schedules,
                                    filter: state?.core?.schedules?.filter,
                                    pendingCount: state?.core?.schedules?.pendingCount
                                },
                                trips: {
                                    ...initialState.core.trips,
                                    filter: null,
                                }
                            },
                            trips: {
                                ...initialState.trips,
                                filters: state?.trips?.filters
                            },
                            shop: {
                                ...initialState.shop,
                                filters: state?.shop?.filters
                            },
                            modals: {
                                ...initialState.modals,
                                layouts: state?.modals?.layouts
                            }
                        })
                        return reducer(storeService.originState, action)
                    }
                    break
                default:
                    break
            }
            return reducer(state, action)
        }
    }
}